import type React from 'react';
import { HiddenText } from '@common/components/HiddenText/HiddenText';
import { Box, Paragraph, Text } from '@zillow/constellation-10';
import ContactLandlordSection from './ContactLandlordSection';
import type { LandlordProfileModel } from '@renter-hub/models/Types';

interface Props {
  landlordProfile: LandlordProfileModel;
  rentTermPaymentsComplete: boolean;
  displayHiddenText: boolean;
}

export const LandlordCard: React.FC<React.PropsWithChildren<Partial<Props>>> = (props) => {
  const renderTitle = () => {
    const { rentTermPaymentsComplete } = props;

    if (!rentTermPaymentsComplete) {
      return <Paragraph textStyle="body-bold">Landlord</Paragraph>;
    }
  };

  const renderBody = () => {
    const { rentTermPaymentsComplete, displayHiddenText, landlordProfile } = props;

    if (displayHiddenText) {
      return (
        <Text>
          <HiddenText visible={displayHiddenText} />
        </Text>
      );
    } else if (rentTermPaymentsComplete) {
      return (
        <Text>
          Contact {landlordProfile?.name} about continuing online payments.&nbsp;
          <ContactLandlordSection />
        </Text>
      );
    } else {
      return <ContactLandlordSection />;
    }
  };

  return (
    <Box css={{ marginTop: 'loose', marginBottom: 'loose' }}>
      {renderTitle()}
      {renderBody()}
    </Box>
  );
};
